import { merge } from 'ramda';

import {
  REQUEST,
  SUCCESS,
  FAIL
} from 'src/store/actions/workTimesByDaysActions';

const initialState = {
  data: {},
  fetching: false
};

const workTimesByDaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { data: action.data, fetching: false });
    case FAIL:
      return merge(state, { fetching: false });
    default:
      return state;
  }
};

export default workTimesByDaysReducer;
